import { useDispatch, useSelector } from "react-redux";
import { updateAlertStatus } from "../../redux/actions/updateAlertStatusAction";
import Button from "@material-ui/core/Button";
import { isNull } from "lodash";
import {
  CREATE_DATA_GUARD_JIRA_INCIDENT,
  DISPLAY_DATA_GUARD_ALERT_COMMENT,
  OPEN_DATA_GUARD_SNACKBAR,
  dataGuardReportIncidentFailed,
  SET_DATA_GUARD_ALERT_STATUS,
} from "./Utility/DataguardConstant";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useState } from "react";
import { renderRevokePopup } from "../../components/common/utilities";

export const DataGuardAlertButtons = ({ alertData, dataSourceId }) => {
  const alertId = alertData?.alertId || null;
  const alertStatus = useSelector((state) => state.DataguardReducer.alertStatus);
  const displayAlertComment = useSelector(
    (state) => state.DataguardReducer.displayAlertComment
  );
  const reportIncidentData = useSelector(
    (state) => state.DataguardReducer.reportIncidentData
  );
  const dispatch = useDispatch();
  const [revokeDetails, setRevokeDetails] = useState(null);
  const [revokePopup, setRevokePopup] = useState(false);

  const handleRevokePopupClose = () => {
    setRevokePopup(false);
  };
  
  const handleRevokeConfirm = () => {
    dispatch({
      type: CREATE_DATA_GUARD_JIRA_INCIDENT,
      payload: {
        alerts: [{ alertId: alertId, dataSourceID: dataSourceId }],
      },
    });
    setRevokePopup(false);
  };

  const renderReportIncident = () => {
    if ((reportIncidentData?.length > 0) || (alertData?.ticketIds && alertData?.ticketIds.length > 0 && alertData?.ticketIds[0])) {
      return (
        <div className="incident-ticket">
          {reportIncidentData?.[0]?.ticketId || alertData?.ticketIds}
        </div>
      );
    } else {
      return (
        <Button
          onClick={() => {
            setRevokePopup(true);
          }}
          disabled={isNull(alertId)}
        >
          Report Incident
        </Button>
      );
    }
  };

  const isAlertActionDisabled = () => {
    if (isNull(alertId) || (!isNull(alertData.alertStatus) &&
          (alertData.alertStatus === "RESOLVED" || alertData.alertStatus === "FALSE_POSITIVE"))) {
      return true;
    }
  }

  return (
    <div className="sys-guard-alert-buttons">
      {renderReportIncident()}
      <Button
        onClick={() => {
          dispatch({
            type: SET_DATA_GUARD_ALERT_STATUS,
            payload: "MARK_RESOLVED",
          });
          dispatch({
            type: DISPLAY_DATA_GUARD_ALERT_COMMENT,
            payload: true,
          });
        }}
        className={
          !isNull(alertStatus) &&
          alertStatus === "MARK_RESOLVED" &&
          displayAlertComment
            ? "alertSelected"
            : ""
        }
        disabled={isAlertActionDisabled()}
      >
        Resolve
      </Button>
      <Button
        onClick={() => {
          dispatch({
            type: SET_DATA_GUARD_ALERT_STATUS,
            payload: "MARK_FALSE_POSITIVE",
          });
          dispatch({
            type: DISPLAY_DATA_GUARD_ALERT_COMMENT,
            payload: true,
          });
        }}
        className={
          !isNull(alertStatus) &&
          alertStatus === "MARK_FALSE_POSITIVE" &&
          displayAlertComment
            ? "alertSelected"
            : ""
        }
        disabled={isAlertActionDisabled()}
      >
        False Positive
      </Button>
      {renderRevokePopup(
        revokePopup,
        revokeDetails,
        handleRevokePopupClose,
        handleRevokeConfirm,
        "dataGuardAnomalies"
      )}
    </div>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const DataGuardAlertStatusSnackBar = () => {
  const dispatch = useDispatch();
  const snackBarSuccessMessage = useSelector(
    (state) => state.DataguardReducer.alertStatusSuccessMessage
  );
  const snackBarFailedMessage = useSelector(
    (state) => state.DataguardReducer.alertStatusFailedMessage
  );
  const alertUpdated = useSelector(
    (state) => state.DataguardReducer.alertStatusUpdateSuccess
  );
  const openSnackbar = useSelector(
    (state) => state.DataguardReducer.openDataGuardSnackBar
  );

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({ type: OPEN_DATA_GUARD_SNACKBAR, payload: false });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openSnackbar}
      autoHideDuration={3000}
      onClose={handleCloseSnackbar}
    >
      <Alert onClose={handleCloseSnackbar} severity={alertUpdated ? "success" : "error"}>
        {alertUpdated ? snackBarSuccessMessage : snackBarFailedMessage}
      </Alert>
    </Snackbar>
  );
};